import React, { useState } from "react";
import { toast } from "react-toastify";
import Handler from "../../../Helpers/Handler";
import { textCapitalize } from "../../../Helpers/Utils";

// carPriceUpdate/bikePriceUpdate replace the WHOLE priceTypes array in one
// call (not a per-row patch) - every row needs all 3 fields filled, and at
// least 1 row must exist, matching priceTypes.*.package/perHourPrice/
// perHourKm all being `.exists()` in the validators.
const emptyRow = () => ({ package: "", perHourPrice: "", perHourKm: "" });

const VehiclePricingPanel = ({ vehicleType, vehicleId, priceTypes, onSaved }) => {
    const [rows, setRows] = useState(priceTypes?.length ? priceTypes.map((p) => ({ package: p.package, perHourPrice: p.perHourPrice, perHourKm: p.perHourKm })) : [emptyRow()]);
    const [saving, setSaving] = useState(false);

    const updateRow = (index, field, value) => setRows((prev) => prev.map((row, i) => (i === index ? { ...row, [field]: value } : row)));
    const addRow = () => setRows((prev) => [...prev, emptyRow()]);
    const removeRow = (index) => setRows((prev) => prev.filter((_, i) => i !== index));

    const onSave = async () => {
        const cleaned = rows.filter((r) => r.package?.trim() || String(r.perHourPrice).trim() || String(r.perHourKm).trim());
        if (!cleaned.length) {
            toast.error("Add at least 1 pricing tier");
            return;
        }
        const invalid = cleaned.some((r) => !r.package?.trim() || String(r.perHourPrice).trim() === "" || String(r.perHourKm).trim() === "" || Number(r.perHourPrice) < 0 || Number(r.perHourKm) < 0);
        if (invalid) {
            toast.error("Each pricing tier needs a package name, a non-negative price, and a non-negative km slab");
            return;
        }
        setSaving(true);
        const payload = cleaned.map((r) => ({ package: r.package.trim(), perHourPrice: Number(r.perHourPrice), perHourKm: Number(r.perHourKm) }));
        const response = await Handler({ method: "patch", url: `/staff/${vehicleType}/${vehicleId}/price`, data: { priceTypes: payload } });
        if (response?.success) {
            toast.success(response?.data?.message || "Pricing updated");
            onSaved?.();
        } else {
            toast.error(textCapitalize(response?.data?.message || "Unable to update pricing"));
        }
        setSaving(false);
    };

    return (
        <div>
            {rows.map((row, index) => (
                <div key={index} className="row g-2 align-items-center mb-2">
                    <div className="col-12 col-md-4">
                        <input type="text" className="form-control" placeholder="Package (e.g. Daily)" value={row.package} onChange={(e) => updateRow(index, "package", e.target.value)} />
                    </div>
                    <div className="col-6 col-md-3">
                        <input type="number" className="form-control" placeholder="Price / hr" min="0" value={row.perHourPrice} onChange={(e) => updateRow(index, "perHourPrice", e.target.value)} />
                    </div>
                    <div className="col-6 col-md-3">
                        <input type="number" className="form-control" placeholder="Km / hr" min="0" value={row.perHourKm} onChange={(e) => updateRow(index, "perHourKm", e.target.value)} />
                    </div>
                    <div className="col-12 col-md-2">
                        {rows.length > 1 ? (
                            <button type="button" className="btn btn-sm btn-outline-danger w-100" onClick={() => removeRow(index)}>Remove</button>
                        ) : null}
                    </div>
                </div>
            ))}
            <div className="d-flex justify-content-between align-items-center mt-2">
                <button type="button" className="btn btn-sm btn-outline-secondary" onClick={addRow}>+ Add tier</button>
                <button type="button" className="btn btn-primary btn-sm" onClick={onSave} disabled={saving}>
                    {saving ? "Saving..." : "Save pricing"}
                </button>
            </div>
        </div>
    );
};

export default VehiclePricingPanel;
